class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = this.querySelector('.cart-drawer');
    this.cartDrawerContainer = this.querySelector('.cart-drawer-container');
    this.cartDrawerIcon = this.querySelector('.header__cart');
    this.lastScrollTop = 0;

    if (!this.cartDrawer || !this.cartDrawerIcon) {
      return;
    }

    window.cartDrawer = {
      add: this.addToCart.bind(this),
      open: this.open.bind(this),
      refresh: this.refresh.bind(this),
    };
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    Shopify.eventEmitter.subscribe('ald:cart:refresh', this.refresh.bind(this));
    Shopify.discount.onUpdated(this.refresh.bind(this));

    this.cartDrawerContainer.addEventListener('click', event => {
      if (!event.target.closest('.cart-drawer')) {
        this.closeCartDrawer();
      }
    });

    this.cartDrawerContainer.addEventListener(
      'swiped-up',
      () => {
        this.closeCartDrawer();
      },
      {passive: true},
    );

    window.addEventListener(
      'scroll',
      () => {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > this.lastScrollTop) {
          this.closeCartDrawer();
        }
        this.lastScrollTop = st <= 0 ? 0 : st;
      },
      {passive: true},
    );

    window.addEventListener('resize', evt => {
      if (window.innerWidth > 989) {
        this.closeCartDrawer(evt);
      }
    });

    this.addEventListener('change', event => {
      if (event.target.closest('.cart-drawer__item-quantity .quantity__input')) {
        event.preventDefault();
        this.updateQuantity(event.target.dataset.itemKey, event.target.value);
      }
    });

    this.addEventListener('click', event => {
      if (event.target.closest('.cart-drawer__item-remove')) {
        event.preventDefault();
        this.removeItem(event.target.closest('.cart-drawer__item-remove').dataset.itemKey);
      }
    });

    this.addEventListener('click', event => {
      if (event.target.closest('.cart-drawer__item-save-for-later')) {
        event.preventDefault();

        if (WishlistKing) {
          WishlistKing.toolkit.addProduct(event.target.dataset.itemId, event.target.dataset.itemVariantId);
          this.removeItem(event.target.dataset.itemKey);
        }
      }
    });

    document.addEventListener('submit', async event => {
      if (event.target.closest('form[action^="/cart/add"]')) {
        event.preventDefault();
        const submitter = event.submitter;

        submitter.classList.add('loading');
        await this.addToCart({form: event.target, redirect: submitter?.name === 'buy_now'});
        submitter.classList.remove('loading');
      }
    });

    this.cartDrawerIcon.addEventListener('click', event => {
      if (window.innerWidth < 750) {
        window.location = '/cart';
      } else {
        this.open();
      }
    });
  }

  open() {
    // TODO: interim fix (cart not opening when adding bundle)
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer.classList.contains('cart-opening')) {
      return;
    }

    cartDrawer.classList.add('cart-opening', 'cart-open-animation');
 
    setTimeout(() => {
      cartDrawer.classList.remove('cart-open-animation');
    }, 500);

    if (!isIOS) {
      disableBodyScroll(this.cartDrawer);
    }
  }

  closeCartDrawer() {
    this.classList.add('cart-close-animation');

    setTimeout(() => {
      this.classList.remove('cart-opening');
      this.classList.remove('cart-close-animation');
    }, 500);

    if (typeof enableBodyScroll === 'function') {
      enableBodyScroll(this.cartDrawer);
    }
  }

  async addToCart({items, form, redirect = false}) {
    const cartItems = [];

    if (form) {
      cartItems.push(this.transformFormData(serializeForm(form)));
    }

    if (items) {
      cartItems.push(...items);
    }

    const body = {
      items: cartItems,
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    };

    return Shopify.cart.add(body).then(state => {
      if (redirect) {
        window.location = '/cart';
      } else {
        this.build(state.sections);
        this.open();
      }
    }).catch(error => console.error(error));
  }

  updateQuantity(key, quantity) {
    const body = {
      updates: {[key]: quantity},
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    };
    Shopify.cart.update(body).then(state => this.build(state.sections));
  }

  removeItem(key) {
    this.updateQuantity(key, 0);
  }

  refresh() {
    fetch(
      `/?sections=${this.getSectionsToRender()
        .map(section => section.section)
        .join()}`,
    )
      .then(response => response.json())
      .then(state => this.build(state));
  }

  build(sections) {
    this.getSectionsToRender().forEach(section => {
      section.selectors.forEach(selector => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], selector);
      });
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'header',
        section: document.getElementById('header').dataset.id,
        selectors: ['.cart-drawer', '.header__cart-count'],
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  transformFormData(formData) {
    const transformedData = {
      id: formData.id,
      quantity: formData.quantity,
      selling_plan: formData.selling_plan,
      note: formData.note,
      properties: {},
    };

    Object.keys(formData).forEach(key => {
      if (key.startsWith('properties[')) {
        const propertyName = key.slice(11, -1);
        transformedData.properties[propertyName] = formData[key];
      }
    });

    return transformedData;
  }
}

customElements.define('cart-drawer', CartDrawer);
